import { CoreConfig } from '@movilidad/app-core/config';

import { BUILD_INFO } from './build-info';
import { environment } from './environment';

/** Lo que @movilidad/app-core lee del ambiente. Las llaves son propias: Passenger no comparte sesión con nadie. */
export const coreConfig: CoreConfig = {
  production: environment.production,
  version: environment.version,
  commitHash: BUILD_INFO.commitHash,
  apiBaseUrl: environment.apiBaseUrl,
  tokenKey: 'passenger_token',
  // Sin cifrado de Preferences todavía: el token se guarda con el login, en TEC-483, y su llave no se
  // versiona en este repo como las de `environment` de apps/app.
  cryptoKey: '',
  storagePrefix: 'passenger_',
  storageEncryption: false,
  // TEC-393: Reverb del propio API. Sin llave, PusherService no se conecta; llega con la instancia (TEC-482).
  pusher: { key: '', cluster: '', forceTLS: true, broadcaster: 'reverb', wsPath: '/reverb' },
};
